import {Injectable} from "@angular/core";
import {OfferInfo} from "~/app/core/model/offer-info";
import {NetworkService} from "~/app/core/network.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import {Share} from "@capacitor/share";

type Position = "top"|"left"|"right"|"bottom";

@Injectable()
export class ShareService {
    private readonly whutsfreeLogoPath: string;
    private readonly whutsfreeColorLogoPath: string;
    constructor(
        private readonly api: ApiService,
        private readonly netService: NetworkService
    ) {
    }

    doShareStandard(offerInfo: OfferInfo, callback: (result: boolean) => void = null) {
        try {
            let message;
            if (offerInfo) {
                message = "Check out this \"" + offerInfo.name + "\" from " + offerInfo.companyName + (offerInfo.companyName.endsWith(".") ? "" : ".") + " Get it using WhutsFree and don't forget my referral code: " + this.api.tickets_personalReferralCode();
            } else {
                message = "Have you seen the WhutsFree app? Install it to get 100% FREE offers! Use my referral code: " + this.api.tickets_personalReferralCode();
            }
            const defaultUrl: string = "https://share.whutsfree.com";

            // if network is available, generate the share message using the server url
            Share.share({
                text: message,
            }).then((result) => {
                console.log(result);
            });
        } catch (error) {
            Log.error(Log.Tag.OffersList, error);
            callback(false);
        }
    }
}
